var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "rack"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card-headerfrm filter_main row",
    staticStyle: {
      "margin": "1px 16px"
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-bottom": "4px"
    }
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('purchaseOrder.viewPurchaseOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-actions col-md-6 "
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    attrs: {
      "title": "Go To Purchase Order "
    },
    on: {
      "click": _vm.showList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('i', {
    on: {
      "ok": function($event) {}
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5 imglogo"
  }, [_c('img', {
    staticClass: "dark-logo",
    attrs: {
      "src": 'static/img/' + _vm.clientdata.logoUrl,
      "alt": "homepage",
      "width": "250",
      "height": "42"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clientdetails"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "30px !important",
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.clientdata.clientname))]), _vm._v(" "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('purchaseOrder.panNo')) + ": " + _vm._s(_vm.clientdata.clientpanid) + " "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('warehouses.gstNumber')) + " : " + _vm._s(_vm.clientdata.clientgstnum) + " "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('purchaseOrder.cinNo')) + " : " + _vm._s(_vm.clientdata.cinnumber) + " "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('purchaseOrder.dlNo')) + " : " + _vm._s(_vm.clientdata.dlno) + " "), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('purchaseOrder.fassaiNo')) + "  : " + _vm._s(_vm.clientdata.fssaino) + "\n            ")])])])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.purchaseOrderDetails')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('purchaseOrder.poSpecial')) + "  " + _vm._s(_vm.PurchaseOrderDetailsData.pono))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.poDate')) + " " + _vm._s(_vm._f("moment")(_vm.PurchaseOrderDetailsData.podate)))])])]), _vm._v(" "), _c('tr', [_vm._v(_vm._s(_vm.$t('purchaseOrder.suplierName')) + "  " + _vm._s(_vm.PurchaseOrderDetailsData.suppliercompanyname)), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.deliveryDate')) + " " + _vm._s(_vm._f("moment")(_vm.PurchaseOrderDetailsData.deliverbydateterms)))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.PurchaseOrderDetailsData.supplieraddressline1)), _c('br'), _vm._v("\n                    " + _vm._s(_vm.PurchaseOrderDetailsData.supplieraddresscity) + ",\n                    " + _vm._s(_vm.PurchaseOrderDetailsData.supplieraddressstate) + ",\n                    " + _vm._s(_vm.PurchaseOrderDetailsData.supplieraddresspin) + ",\n                    " + _vm._s(_vm.PurchaseOrderDetailsData.supplieraddresscountry)), _c('br'), _vm._v("\n                    Phone No.: " + _vm._s(_vm.PurchaseOrderDetailsData.supplieraddressphone) + "\n                  ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.poDescription')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.podescription) + "\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.paymentTerms')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.paymentterms) + "\n                  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', {
    staticClass: "col-md-12 col-lg-12 col-sm-12"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.emailId')) + " " + _vm._s(_vm.supplierdata.merchantpersonemail)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.panNumber')) + " " + _vm._s(_vm.supplierdata.merchantpanid)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + " " + _vm._s(_vm.supplierdata.merchantpersonname) + "\n                  ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.FobTerms')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.fobterms) + "\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.$t('purchaseOrder.carrier')) + "  " + _vm._s(_vm.PurchaseOrderDetailsData.carrierterms) + "\n                  ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('merchant.foodLicenseNo')) + ": " + _vm._s(_vm.supplierdata.foodlicenseno)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.$t('merchant.drugLicenseNo')) + ": " + _vm._s(_vm.supplierdata.druglicenseno)), _c('br'), _vm._v("\n                  " + _vm._s(_vm.$t('warehouses.gstNumber')) + ": " + _vm._s(_vm.supplierdata.suppliergstnno)), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('label', [_vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.freightTerm')) + "  " + _vm._s(_vm.PurchaseOrderDetailsData.freightterms)), _c('br'), _c('br'), _vm._v("\n                  " + _vm._s(_vm.$t('purchaseOrder.comments')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.comments) + "\n\n                  ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered bottomfields1",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary",
    attrs: {
      "width": "100%"
    }
  }, [_c('th', {
    staticClass: "tableheader"
  }, [_vm._v("  " + _vm._s(_vm.$t('purchaseOrder.shipTo')) + ": ")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    attrs: {
      "width": "100%"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.invoiceTo')) + ":")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "bottomfields"
  }, [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.PurchaseOrderDetailsData.shiptocompanyname))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.PurchaseOrderDetailsData.billtocompanyname) + ":")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.PurchaseOrderDetailsData.shiptoaddressline1) + " " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddressline2))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.PurchaseOrderDetailsData.billtoaddressline1) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("\n                        " + _vm._s(_vm.$t('client.city')) + ":  " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddresscity)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.state')) + ":" + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddressstate)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.pinCode')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddresspin)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.country')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddresscountry) + "\n                        ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("\n                        " + _vm._s(_vm.$t('client.city')) + ":  " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddresscity)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.state')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddressstate)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.pinCode')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddresspin)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.$t('client.country')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddresscountry) + "\n                        ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('merchant.phoneNumber')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddressphone))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('merchant.phoneNumber')) + ": " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddressphone))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v("  " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.shiptoaddresscontactperson))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.contactPerson')) + " " + _vm._s(_vm.PurchaseOrderDetailsData.billtoaddresscontactperson))])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left": "16px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "width": "50px",
      "display": "table-cell",
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('warehouseRacks.LineNo')) + ".")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "width": "200px",
      "display": "table-cell",
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    },
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    },
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.qty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    },
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.hsnCode')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    },
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.ptr')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    },
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.gstRate')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.mrp')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Uom')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "width": "80px",
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.discount')) + " (%)")]), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))]), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sgst')))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.sgst')) + " %")]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.cgst')))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.cgst')) + " %")]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate != _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.igst')))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate != _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.igst')) + " %")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tableheader",
    staticStyle: {
      "width": "100px",
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.totalWithTax')))])])]), _vm._v(" "), _vm._l((_vm.PurchaseOrderLoopData), function(items) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "width": "50px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(items.productlinenumber))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(items.productname))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-break": "break-word"
      }
    }, [_vm._v(_vm._s(items.eancode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.hsncode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.hsnrate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "100px",
        "display": "table-cell",
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(items.productunitofmeasure))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.mrp)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.productunitprice)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(items.discount))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes)))]), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(items.sgstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.sgstratepercent / 100)))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(items.cgstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.cgstratepercent / 100)))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate != _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(items.igstratepercent))]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate != _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithouttaxes * items.igstratepercent / 100)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.getScore(items.totalpricewithtax)))])])])
  }), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate != _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.subtotal')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithouttaxes)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.applicableTax')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.sgst + _vm.cgst + _vm.igst)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Freight')))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.PurchaseOrderDetailsData.shippingcharges)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "12"
    }
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithtax)))])])]) : _vm._e(), _vm._v(" "), (_vm.PurchaseOrderDetailsData.supplieraddressstate == _vm.PurchaseOrderDetailsData.shiptoaddressstate) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "14"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.subTotal')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithouttaxes)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "14"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.applicableTax')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.sgst + _vm.cgst + _vm.igst)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "14"
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.Freight')))])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.PurchaseOrderDetailsData.shippingcharges)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "14"
    }
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('purchaseOrder.total')))])])]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.getScore(_vm.totalpricewithtax)))])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('purchaseOrder.signature')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('errorLogReport.date')) + ":")]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.yourName')))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('purchaseOrder.yourDesignation')))])])])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('common.print')))])])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eda73204", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eda73204","hasScoped":true}!./src/views/components/purchaseOrder/printpo.component.html
// module id = 1244
// module chunks = 0